import {
  SupplierDeleteParams
} from '@gateway.maintenance'
import { yamadumiApi } from '../yamadumi-api'

/**
 * 業者マスタメンテナンス-一括削除のゲートウェイクラス
 */
export class SupplierItemDeleteGateway {
  /**
   * 業者マスタメンテナンス-一括削除
   */
  static deleteSupplierSearchItem = async (params: SupplierDeleteParams) => {
    return await yamadumiApi.delete('/api/maintenance/supplier/item/delete', { ...params })
  }
}
